<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    Carta aos Inscritos
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Texto ao informar</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="type-width" appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
              <mat-option *ngFor="let type of types" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="entityForm.controls.type.hasError('required')">
              O Típo é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Titulo do Email</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.subject"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.subject.hasError('required')">
              O Título é obrigatório
            </mat-error>
          </mat-form-field>

          <ckeditor [editor]="Editor" [config]="{ 
                toolbar: [ 'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ]
               }" [formControl]="entityForm.controls.text"></ckeditor>
          <mat-error *ngIf="entityForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>

        </div>

      </mat-tab>

      <mat-tab *ngIf="entityForm.controls.type.value === '0'">
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Texto ao interagir</div>
        </ng-template>

        <div class='tab-content'>
          <br>
          <p>
            Ao receber este e-email, o assinante será convidado a acionar um link, navegar para uma página e registrar
            sua opinião.
          </p>
          <p>
            Este é o texto que será apresentado ao assinante quando o link do e-mail for clicado.
          </p>
          <p>
            O texto é livre, apenas deve conter a tags para que o sistema possa substituí-las pela texto apropriada.
          </p>

          <ckeditor [editor]="Editor" [config]="{ 
            toolbar: [ 'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ]
           }" [formControl]="entityForm.controls.text_back"></ckeditor>
          <mat-error *ngIf="entityForm.controls.text_back.hasError('required')">
            O Texto é obrigatório
          </mat-error>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Imgem no email</div>
        </ng-template>

        <div class='tab-content-img'>

          <div style="width: 100%; text-align: center;">
            <p>Esta imagem irá aparecer no topo do email enviado. </p>
            <p>O tamanho ideal desta imagem é de 300 x 600 pixels</p>
          </div>

          <div class='img-input'>
            <input #file type="file" accept='image/*' style='display:none' (change)="previewImage($event)" />
          </div>
          <div class="post-image">
            <img [src]="storedImage" *ngIf="storedImage">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>
        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button matTooltip='Insert' mat-raised-button (click)="matDialogRef.close(['insert',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>


</div>